import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { SimpleFieldValue } from '../../../../entities/field-values/field-type-values.entity';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShBaseGenericReadonlyFieldComponent } from '../../base-generic-readonly-field/base-generic-readonly-field.component';

@Component({
    selector: 'sh-simple-readonly-field',
    templateUrl: './simple-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShSimpleReadonlyFieldComponent extends ShBaseGenericReadonlyFieldComponent implements OnDestroy {
    public value$ = new ReplaySubject<SimpleFieldValue | void>(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        const value: SimpleFieldValue = this.fieldHelper.getSimpleFieldValue(profileField.FieldDefinition, record);
        this.value$.next(value);
    }

    ngOnDestroy(): void {
        this.value$.next();
        this.value$.complete();

        super.ngOnDestroy();
    }
}
